import { Component } from '@angular/core';

@Component({
  selector: 'app-cgu-fr',
  templateUrl: './cgu-fr.component.html',
  styleUrls: ['./cgu-fr.component.scss'],
  standalone: false,
})
export class CguFrComponent {}
